import { GearSix } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { InboxFooterProps } from './InboxFooter.types';

export const InboxFooter = ({
  microcopy,
  onSettingsClick,
  className = '',
}: InboxFooterProps) => {
  return (
    <div
      className={c(
        'w-full rounded-b-lg border-t border-t-white/[0.08] bg-[#202020] px-3 py-1',
        className
      )}
    >
      <button
        type="button"
        onClick={onSettingsClick}
        className="p-1.5"
        aria-label={microcopy.openSettingsAriaLabel}
      >
        <GearSix className="h-5 w-5 text-grey-400" />
      </button>
    </div>
  );
};
